import { render, staticRenderFns } from "./feeDeduction.vue?vue&type=template&id=164c5740&scoped=true&"
import script from "./feeDeduction.vue?vue&type=script&lang=js&"
export * from "./feeDeduction.vue?vue&type=script&lang=js&"
import style0 from "./feeDeduction.vue?vue&type=style&index=0&id=164c5740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c5740",
  null
  
)

export default component.exports